import { COLLECTION_TABS } from "@healthos/shared";
export const LIBRARY_TABS = [
    { id: "all", label: "All" },
    ...COLLECTION_TABS,
    { id: "personalReset", label: "Personal" },
    { id: "brief", label: "Briefs" },
];
//# sourceMappingURL=library-types.js.map